import React, { Component } from 'react';
import './App.css';
import SwaggerUIWrapper from "./components/SwaggerUIWrapper";

class App extends Component {
  render() {
    return (
      <div>
          <SwaggerUIWrapper/>
      </div>
    );
  }
}

export default App;
